import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "editor",
    class: "medium-editor-container",
    onCopy: _cache[0] || (_cache[0] = (...args) => ($options.onSelectionCopy && $options.onSelectionCopy(...args)))
  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */))
}